import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
	return (
		<DefaultFooter
			style={{
				background: 'none'
			}}
			copyright="Powered by Atomic Art"
			links={[
				{
					key: '珠海优迅文化传播有限公司 - 原子艺术',
					title: '珠海优迅文化传播有限公司 - 原子艺术',
					href: 'https://www.atomic-art.com/',
					blankTarget: true
				}
			]}
		/>
	);
};

export default Footer;
